"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.sizes = exports.componentArgs = exports.availableVariants = exports.availableSizes = void 0;
var sizes = exports.sizes = Object.freeze({
  MEDIUM: "medium",
  SMALL: "small"
});
var variants = exports.variants = Object.freeze({
  CONTAINED: "contained",
  OUTLINED: "outlined",
  TEXT: "text"
});
var availableSizes = exports.availableSizes = Object.freeze(Object.values(sizes));
var availableVariants = exports.availableVariants = Object.freeze(Object.values(variants));
var componentArgs = exports.componentArgs = {
  disabled: {
    description: "Prevents user interaction with the button",
    table: {
      defaultValue: {
        summary: false
      },
      type: {
        summary: "boolean"
      }
    }
  },
  fullWidth: {
    description: "Determines if it extends to 100% of the container width",
    table: {
      defaultValue: {
        summary: false
      },
      type: {
        summary: "boolean"
      }
    }
  },
  size: {
    description: "Determines the size of the button",
    control: {
      type: "select"
    },
    table: {
      defaultValue: {
        summary: sizes.MEDIUM
      },
      type: {
        summary: "string"
      }
    },
    options: availableSizes
  },
  variant: {
    description: "Determines the variant of the button",
    control: {
      type: "select"
    },
    table: {
      defaultValue: {
        summary: variants.CONTAINED
      },
      type: {
        summary: "string"
      }
    },
    options: availableVariants
  }
};